import React from 'react';
import classNames from 'classnames';
import subChineseStr from '../subChineseStr';
require('./ApprovalAvatar.scss');

const ApprovalAvatar = props => {
    const info = props.info;
    if(info.hasAvatar) {
        const avatarInfo = info.avatar;
        if(avatarInfo.headPortrait) {
            return (<img src={avatarInfo.headPortrait} className={classNames('approval-item-avatar',props.cls)} key={avatarInfo.id} />);
        }
        return (<div key={avatarInfo.id} className={classNames('approval-item-avatar',props.cls)} style={{ 'backgroundColor': avatarInfo['color'] }}>{subChineseStr(avatarInfo.name,1)}</div>);
    }
    return null;
};

export default ApprovalAvatar;


// WEBPACK FOOTER //
// ./src/components/Approval/new/ApprovalAvatar.js